exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-b11c9656],th[data-v-b11c9656]{width:170px}th.series-cell[data-v-b11c9656]{width:46px;background-color:#f7f7f7}th.series-cell>span[data-v-b11c9656]{white-space:nowrap;-ms-writing-mode:tb-lr;writing-mode:vertical-lr;transform:rotate(180deg)}.sticky-cell-left-170[data-v-b11c9656]{position:-webkit-sticky;position:sticky;left:170px}", ""]);

// exports
